import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const uMLanguagesApi = createApi({
  reducerPath: 'uMLanguagesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Languages'],
  endpoints: builder => ({
    // Retrieve languages
    getLanguages: builder.query({
      query: (params) => ({
        url: `/utils/languages/`,
        params,
      }),
      providesTags: ['Languages'],
    }),
  }),
});

export const {
  useGetLanguagesQuery,
} = uMLanguagesApi;
